import React from 'react';
import './CommentItem.scss';

const CommentItem = ({ comment }) => {
  return (
    <div className="comment-item-container">
      <div className="comment-info">
        <p className="comment-by">by {comment.by}</p>
        <p>2 hours ago</p>
      </div>
      <div className="comment-content">
        <p dangerouslySetInnerHTML={{ __html: comment.text }}></p>
      </div>
    </div>
  );
};

export default CommentItem;
